import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import faviconUrl from 'assets/images/favicon.ico';
import { HashRouter } from 'react-router-dom';
import AuthProvider from './auth-provider';
import 'normalize.css';
import 'assets/styles.css';
import { theme } from './theme';
import { App } from './app';

const setFavicon = (href: string) => {
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    document.head.appendChild(link);
  }
  link.href = href;
};
setFavicon(faviconUrl);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <HashRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HashRouter>
  </ThemeProvider>,
  document.getElementById('root')
);
